<template>
    <div class="col-lg-4 col-md-6 col-12">
        <router-link :to="link">
            <div class="card card--activity">
                <div class="card__deal-type">
                    <h4>{{ activityType }}</h4>
                </div>
                <div class="grid justify-space-between align-center">
                    <div class="col-lg-4 col-12">
                        <picture class="card__thumbnail">
                            <img :src="backgroundUrl" alt="Activity Image" class="card__image">
                        </picture>
                    </div>
                    <div class="col-lg-8 col-12">
                        <h3 class="card__title">{{ activityName }}</h3>
                        <span class="card__activity_type">{{ start }} - {{ end }}</span>
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'ActivityCard',
        props: {
            id: {
                type: Number,
                required: true
            },
            activityName: {
                type: String,
                required: true
            },
            activityType: {
                type: String,
                required: true
            },
            backgroundUrl: {
                type: String,
                default: null
            },
            start: {
                type: String,
                default: null
            },
            end: {
                type: String,
                default: null
            },
        },
        computed: {
            link() {
                return { name: 'view-activity', params: { activity_id: this.id }};
            }
        }
    }
</script>

<style scoped lang="scss">
.card--activity {
    &, * {
        color: #000000;
    }

    .card__deal-type {
        h4 {
            font-weight: bold;
        }
    }

    .card__thumbnail {
        width: 100%;
        height: auto;
        border-radius: 1rem;
        overflow: hidden;
        display: block;
        line-height: 0;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            max-width: initial;
        }
    }
}
</style>
